<script setup>
import config from '@/common/config'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive, ref } from 'vue'
import ManGroup from '../ManGroup.vue'
import { get, openWin, post, qsel, senitizeFileName, strToXml, valFromObjInArr, validators, xmlToStr, ymd } from '@/common/util'
import markerIcons from '@/common/markerIcons'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import PreviewMap from '@/components/PreviewMap.vue'
import { genSld } from '@/common/sld'
import ConfirmCard from '@/components/ConfirmCard.vue'
import Logs from '../config/Logs.vue'
import { useRouter,useRoute } from 'vue-router'
import { onBeforeRouteUpdate } from 'vue-router'
const router=useRouter(),route=useRoute(),meta=reactive({types:[{tk:'dotmarker',val:'Point'},{tk:'lines',val:'Line'},{tk:'facespolygons',val:'Polygon'},{tk:'sldstylefiles',val:'Manual'},{tk:'streetview',val:'Streetview'}],data:{rows:[]}
    ,searchgroups:[],searchgroupid:'all',tartbl:'Layerstyle',markertypes:['shape','img'],layergroups:[],layers:[],search:{page:1,size:20,isasc:false,sortcol:'mdt',where:{nm:''}}
    ,heads:[{tk:'uniquenumber',col:'id'},{tk:'type',col:'styletype'},{tk:'preview'},{tk:'groupname',col:'groupid'},{tk:'name',col:'nm'},{tk:'registrationmodificationdate',col:'mdt'}],tblheight:400
    ,initstyle:{groupid:'defaultgroups',markertype:'shape',markersize:20,markeropacity:100,fontsize:20,shapecolor:'#000000',fontcolor:'#000000',fontnm:'Malgun Gothic',fontstyle:'normal',usetext:false,usepoint:true,fieldnm:null,etc:null
      ,strokecolor:'#000000',strokewidth:2,strokedasharray:[],strokeopacity:100,fillcolor:'#000000',fillwidth:2,fillopacity:100}})
  ,metaStore=useMetaStore(),previewmap=ref(null),dasharrays=ref([[],[5,5],[10,10],[2,2],[15,5],[20,10]])
,pop=async(type,id)=>{
  meta.poptype=null
  meta.selid=id
  if(type=='save'&&meta.seltype=='Manual'){
    const xml=strToXml(meta.selstyle.sldbody)
    if(xml.getElementsByTagNameNS('*','parsererror').length)return metaStore.toastKey('wrong_sld',false)
  }
  metaStore.pop({ison:type!=null,callback:()=>meta.poptype=type,onclose:()=>{
    if(type=='mangroup')return initGroups()
    if(type=='pop')meta.selid=null
  }})
},selImg=async(evt)=>{
  const files=evt.target.files
  if(!files.length)return
  const reader=new FileReader()
  reader.onload=rslt=>{
    meta.selstyle.markerdata=rslt.target.result
    refreshPreview()
  }
  reader.readAsDataURL(files[0])
},selShape=async(icon)=>{
  meta.selstyle.shapenm=icon.name
  meta.selstyle.shapecode=icon.code
  if(meta.seltype=='Streetview'){
    const pointsld=genSld({...meta.selstyle,styletype:'Point',layernm:'sample_point',imgDataUrl:meta.selstyle.markerdata})
    const linesld=genSld({...meta.selstyle,styletype:'Line',layernm:'sample_line'})
    previewmap.value.refreshLayers([meta.ws+':'+'sample_point',meta.ws+':'+'sample_line'],[pointsld,linesld])
  }else previewmap.value.refreshLayers([meta.ws+':sample_'+meta.seltype.toLowerCase()],[previewSld()])
},initGroups=async()=>{
  metaStore.blockLoading()
  const res=await get('rest/authed/member/groups/'+meta.tartbl)
  metaStore.blockLoading(false)
  meta.groups=res.data
  meta.groups.splice(0,0,{id:'defaultgroups',nm:metaStore.t('defaultgroups'),tartbl:meta.tartbl})
  meta.searchgroups=[...meta.groups]
  meta.searchgroups.splice(0,0,{id:'all',nm:metaStore.t('all'),tartbl:meta.tartbl})
},debouncedPreview=_.debounce(()=>{
  let layernms=[],slds=null
  if(meta.seltype=='Manual'){
    if(_.isEmpty(meta.selstyle.sldbody))return
    let layernm
    const xml=strToXml(meta.selstyle.sldbody)
    if(xml.getElementsByTagNameNS('*','parsererror').length)return metaStore.toastKey('wrong_sld',false)
    if(xml.getElementsByTagNameNS('*','PointSymbolizer').length)layernm='point'
    else if(xml.getElementsByTagNameNS('*','LineSymbolizer').length)layernm='line'
    else if(xml.getElementsByTagNameNS('*','PolygonSymbolizer').length)layernm='polygon'
    else if(xml.getElementsByTagNameNS('*','RasterSymbolizer').length)layernm='raster'
    if(!layernm&&xml.getElementsByTagNameNS('*','TextSymbolizer').length)layernm='point'
    if(!layernm)return
    layernm='sample_'+layernm
    let layerel=xml.getElementsByTagNameNS('*','NamedLayer')
    if(!layerel.length)layerel=xml.getElementsByTagNameNS('*','UserLayer')
    if(!layerel.length)return
    layerel=layerel[0]
    let nmel=layerel.querySelector(':scope > Name')
    if(!nmel){
      nmel=xml.createElement('Name')
      nmel.textContent=layernm
      layerel.appendChild(nmel)
    }else nmel.textContent=layernm
    xml.getElementsByTagNameNS('*','PropertyName').forEach(node=>node.textContent='txt')
    slds=[xmlToStr(xml)]
    layernms=[layernm]
  }else if(meta.seltype=='Streetview'){
    const pointsld=genSld({...meta.selstyle,styletype:'Point',layernm:'sample_point',imgDataUrl:meta.selstyle.markerdata})
    const linesld=genSld({...meta.selstyle,styletype:'Line',layernm:'sample_line'})
    if(meta.selstyle.usepoint){
      layernms=[meta.ws+':'+'sample_point',meta.ws+':'+'sample_line']
      slds=[pointsld,linesld]
    }else{
      layernms=[meta.ws+':'+'sample_line']
      slds=[linesld]
    }
  }else layernms=[meta.ws+':sample_'+meta.seltype.toLowerCase()]
  if(!slds)slds=[previewSld()]
  previewmap.value.refreshLayers(layernms,slds)
},500)
,refreshPreview=()=>debouncedPreview()
,delStyle=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/'+'deletelayerstyle',{id:meta.selid})
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,false)
  meta.selid=null
  search()
},modStyle=async()=>{
  const poststyle={...meta.selstyle,strokedasharray:meta.selstyle.strokedasharray.toString()}
  if(poststyle.groupid=='defaultgroups')poststyle.groupid=null
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/'+(meta.selstyle.id?'mod':'add')+'layerstyle',poststyle)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  if(res.isSuccess){
    meta.selstyle=null
    search()
  }
},detailStyle=async layerstyle=>{
  meta.selstyle={...layerstyle}
  if(meta.selstyle.styletype=='Manual'&&meta.selstyle.id){
    metaStore.blockLoading()
    const res=await get('rest/public/stylesld/'+meta.selstyle.id)
    meta.selstyle.sldbody=res.data
    metaStore.blockLoading(false)
  }
  if(!meta.selstyle.groupid)meta.selstyle.groupid='defaultgroups'
  refreshPreview()
  router.push({hash: '#new_or_detail'})
},disabledSave=()=>{
  if(_.isEmpty(meta.selstyle.nm))return true
  if(meta.selstyle.etc!=null&&_.isEmpty(meta.selstyle.nm))return true
  if(meta.selstyle.usetext&&_.isEmpty(meta.selstyle.fieldnm))return true
  return false
},sldFromFile=evt=>{
  const files=evt.target.files
  if(!files.length)return
  const reader=new FileReader()
  reader.onload=rslt=>{
    meta.selstyle.sldbody=rslt.target.result
  }
  reader.readAsText(files[0])
},sort=col=>{
  if(!meta.data.rows.length)return
  if(meta.search.sortcol!=col)meta.search.sortcol=col
  else meta.search.isasc=!meta.search.isasc
  search()
},previewSld=()=>{
  return genSld({...meta.selstyle,layernm:'sample_'+meta.seltype.toLowerCase(),imgDataUrl:meta.selstyle.markerdata,fieldnm:'txt'})
},search=async()=>{
  initGroups()
  if(meta.searchgroupid=='all')delete meta.search.where.groupid_eq_
  else if(meta.searchgroupid=='defaultgroups')meta.search.where.groupid_eq_=null
  else meta.search.where.groupid_eq_=meta.searchgroupid
  meta.search.where.styletype_eq_=meta.seltype
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/layerstyles',meta.search)
  metaStore.blockLoading(false)
  meta.data=res.data
  meta.tblheight=window.innerHeight-420
}
meta.seltype=meta.types[0].val
meta.initstyle.shapenm=markerIcons[0].name
meta.initstyle.shapecode=markerIcons[0].code
get('rest/public/gsfonts',res=>meta.fonts=res.data.fonts.entry)
get('rest/authed/member/gsws',res=>meta.ws=res.data)
search()
onBeforeRouteUpdate((to, from) => {
  if(!to.hash||to.hash=='')meta.selstyle=null
})
</script>
<template>
<div class="admmanstyle">
  <v-card v-if="!meta.selstyle" flat>
    <v-card-title>
      {{ $t('managestyles') }}
      <v-tabs color="deep-purple-accent-4" v-model="meta.seltype" @update:model-value="search">
        <v-tab v-for="type in meta.types" :key="type.val" :value="type.val">{{ $t(type.tk) }}</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-tabs-window v-model="meta.seltype">
        <v-tabs-window-item v-for="type in meta.types" :key="type.val" :value="type.val">
          <v-row>
            <v-col><v-select hide-details variant="outlined" density="compact" :items="meta.searchgroups" item-title="nm" item-value="id" v-model="meta.searchgroupid"/></v-col>
            <v-col cols="3"><v-text-field variant="outlined" density="compact" v-model="meta.search.where.nm"/></v-col>
            <v-col><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search"/></v-col>
            <v-col></v-col>
            <v-col cols="1" class="ps-1 pe-1 me-3"><v-btn :text="$t('managegroups')" @click="pop('mangroup')"/></v-col>
            <v-col cols="1" class="ps-1 pe-1 me-3"><v-btn  color="primary" :text="$t('newregistration')" @click="detailStyle({...meta.initstyle,styletype:meta.seltype})"/></v-col>
          </v-row>
          <v-table class="manstyletbl" fixed-header :height="meta.tblheight">
            <thead>
              <tr>
                <th v-for="head in meta.heads" class="cursor-pointer" @click="sort(head.col)">{{ $t(head.tk) }}
                  <v-icon v-if="meta.data.rows.length&&head.col==meta.search.sortcol" :icon="meta.search.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
                </th>
                <th>{{ $t('viewdetails') }}</th>
                <th>{{ $t('viewlogs') }}</th>
                <th>{{ $t('download') }}</th>
                <th>{{ $t('delete') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in meta.data.rows">
                <td v-for="head in meta.heads" class="text-center">
                  <div v-if="head.col=='mdt'">{{ ymd(row[head.col]) }}</div>
                  <img v-else-if="head.tk=='preview'&&row.styletype!='Streetview'" style="max-width: 50px;max-height: 50px;" :src="config.backend+'previewstyle/'+row.id"/>
                  <div v-else-if="head.tk=='preview'&&row.styletype=='Streetview'">
                    <img v-if="row.usepoint" style="max-width: 50px;max-height: 50px;" :src="config.backend+'previewstyle/'+row.id+'/Point'"/>
                    <img style="max-width: 50px;max-height: 50px;" :src="config.backend+'previewstyle/'+row.id+'/LineString'"/>
                  </div>
                  <div v-else-if="head.col=='groupid'">{{ valFromObjInArr(meta.data.subrows.groups,'id',row[head.col],'nm',$t('defaultgroups')) }}</div>
                  <div v-else-if="head.col=='styletype'">{{ $t(valFromObjInArr(meta.types,'val',row[head.col],'tk')) }}</div>
                  <div v-else-if="head.col">{{ row[head.col] }}</div>
                </td>
                <td class="text-center"><v-btn :text="$t('viewdetails')" @click="detailStyle(row)"/></td>
                <td class="text-center"><v-btn :text="$t('viewlogs')" @click="pop('log',row.id)"/></td>
                <td class="text-center"><v-btn  color="primary" prepend-icon="mdi-download-box-outline" :text="$t('download')" @click="openWin(config.backend+'rest/public/downsld/'+row.id)"/></td>
                <td class="text-center"><v-btn color="error" :text="$t('delete')" @click="pop('del',row.id)"/></td>
              </tr>
              <tr v-if="!meta.data.rows.length">
                <td :colspan="meta.heads.length+3" class="text-center">{{ $t('noresultsfound') }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-card-text>
    <v-card-actions>
      <v-pagination class="ma-auto" v-if="meta.data.rows.length>0" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.search.page" @update:model-value="search"/>
    </v-card-actions>
  </v-card>
  <v-card v-else>
    <v-card-title>
      {{ $t(meta.types.find(type=>type.val==meta.seltype).tk) }}
      {{ $t(meta.selstyle.id?'modify':'newregistration') }}
    </v-card-title>
    <v-card-text>
      <v-row class="pa-3">
        <v-col style="max-width: 520px;">
          <v-defaults-provider :defaults="{VNumberInput:{min:1,max:100}}">
            <v-card flat>
              <v-card-text style="height: calc(100vh - 290px);overflow-y: auto;">
                <v-row>
                  <v-col>
                    <v-select hide-details variant="outlined" density="compact" :disabled="meta.selstyle.etc!=null" :label="$t('selectagroup')" v-model="meta.selstyle.groupid" :items="meta.groups" item-title="nm" item-value="id"/>
                  </v-col>
                  <v-col>
                    <v-btn variant="outlined" density="compact" size="40" :prepend-icon="meta.selstyle.etc===null?'mdi-plus':'mdi-minus'" @click="meta.selstyle.etc=meta.selstyle.etc!=null?null:''"/>
                  </v-col>
                </v-row>
                <v-row v-if="meta.selstyle.etc!=null">
                  <v-col><v-text-field variant="outlined" density="compact" :label="$t('newgroupname')" :placeholder="$t('enteranameforyourgroupupto50characters')" maxlength="50"
                    :rules="[validators.required]" v-model="meta.selstyle.etc"/></v-col>
                </v-row>
                <v-row>
                  <v-col><v-text-field variant="outlined" density="compact" :label="$t('stylename')" :placeholder="$t('enteranameforyourstyleupto50characters')" :rules="[validators.required]"  maxlength="50"
                    v-model="meta.selstyle.nm" @update:model-value="val=>meta.selstyle.nm=senitizeFileName(val)"/></v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select hide-details variant="outlined" density="compact" disabled :label="$t('styletypes')" :items="meta.types" :item-title="item=>$t(item.tk)" item-value="val" :model-value="meta.seltype"/>
                  </v-col>
                </v-row>
                <div v-if="meta.seltype=='Point'||meta.seltype=='Streetview'">
                  <v-row>
                    <v-col>
                      <!-- <div v-if="meta.seltype=='Streetview'">
                        <v-switch hide-details color="primary" :label="$t('dotmarker')+' '+$t('exposure')" v-model="meta.selstyle.usepoint" @update:model-value="refreshPreview"/>
                      </div> -->
                      <v-tabs color="deep-purple-accent-4" v-model="meta.selstyle.markertype" @update:model-value="refreshPreview()">
                        <v-tab v-for="type in meta.markertypes" :value="type">{{ $t(type) }}</v-tab>
                      </v-tabs>
                      <v-tabs-window v-model="meta.selstyle.markertype">
                        <v-tabs-window-item v-for="type in meta.markertypes" :value="type" style="height: 180px;overflow-y: auto;overflow-x: hidden;">
                          <div v-if="meta.selstyle.markertype=='shape'" style="display: flex;flex-wrap: wrap;margin-top: 5px;">
                            <div v-for="icon in markerIcons" :class="`stylemarkericon cursor-pointer${meta.selstyle.shapenm==icon.name?' selmarker':' unselmarker'}`" @click="selShape(icon)">
                              <i :class="`material-icons ${icon.name}`" :style="meta.selstyle.shapecolor?'color:'+meta.selstyle.shapecolor:''"/>
                            </div>
                          </div>
                          <v-row v-else>
                            <v-col class="text-center" style="padding-top: 50px;">
                              <div v-if="!meta.selstyle.markerdata">
                                <v-icon icon="mdi-image-area-close" size="32"/>
                                <div>{{ $t('nofilesareregistered') }}</div>
                              </div>
                              <img v-else class="markerimg" :src="meta.selstyle.markerdata"/>
                            </v-col>
                            <v-col>
                              <v-alert :title="$t('uploadfile')" class="bg-cyan-accent-1">
                                <div>
                                  (권장 사이즈 32X32 Px, png,jpg 만 업로드가능)
                                </div>
                                <input class="markerfile d-none" type="file" accept=".png,.jpg" @change="selImg"/>
                                <v-btn block color="primary" class="mt-3" :text="$t('uploadfile')" @click="qsel('.markerfile').click()"/>
                              </v-alert>
                            </v-col>
                          </v-row>
                        </v-tabs-window-item>
                      </v-tabs-window>
                    </v-col>
                  </v-row>
                  <v-row v-if="meta.selstyle.markertype=='shape'">
                    <v-col align-self="center">{{ $t('dotmarkersize') }}</v-col>
                    <v-col cols="4">
                      <v-number-input inset hide-details variant="outlined" density="compact" v-model="meta.selstyle.markersize" @update:model-value="refreshPreview"/>
                    </v-col>
                  </v-row>
                  <v-row v-if="meta.selstyle.markertype=='shape'">
                    <v-col align-self="center">{{ $t('dotmarker') }}{{ $t('transparency') }}</v-col>
                    <v-col cols="4">
                      <v-number-input hide-details inset variant="outlined" density="compact" :min="0" v-model="meta.selstyle.markeropacity" @update:model-value="refreshPreview"/>
                    </v-col>
                  </v-row>
                  <v-row v-if="meta.selstyle.markertype=='shape'">
                    <v-col align-self="center">{{ $t('dotmarker') }} {{ $t('changecolor') }}</v-col>
                    <v-col cols="4">
                      <v-btn block variant="outlined" class="position-relative">
                        <input type="color" :value="meta.selstyle.shapecolor" style="position: absolute;width: 90%;height: 90%;" @change="evt=>{
                          meta.selstyle.shapecolor=evt.target.value
                          refreshPreview()
                        }"/>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="meta.seltype=='Line'||meta.seltype=='Polygon'||meta.seltype=='Streetview'">
                  <v-row>
                    <v-col align-self="center">{{ $t('linecolorsize') }}</v-col>
                    <v-col>
                      <v-btn block variant="outlined" class="position-relative">
                        <input type="color" :value="meta.selstyle.strokecolor" style="position: absolute;width: 90%;height: 90%;" @change="evt=>{
                          meta.selstyle.strokecolor=evt.target.value
                          refreshPreview()
                        }"/>
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-number-input hide-details inset variant="outlined" density="compact" v-model="meta.selstyle.strokewidth" @update:model-value="refreshPreview"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col align-self="center">{{ $t('line') }} {{ $t('transparency') }}</v-col>
                    <v-col cols="4">
                      <v-number-input hide-details inset variant="outlined" density="compact" :min="0" v-model="meta.selstyle.strokeopacity" @update:model-value="refreshPreview"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col align-self="center" cols="3">{{$t('linetypes')}}</v-col>
                    <v-col cols="6" align-self="center">
                      <v-menu v-model="meta.ondasharray" :items="dasharrays">
                        <template v-slot:activator="{props}">
                          <svg style="width:100%;height:20px;cursor: pointer;" v-bind="props">
                              <line x1="0" y1="50%" x2="100%" y2="50%" stroke="black" :stroke-width="meta.selstyle.strokewidth" :style="{stroke:meta.selstyle.strokecolor}" :stroke-dasharray="meta.selstyle.strokedasharray"/>
                            </svg>
                        </template>
                        <v-list>
                          <v-list-item v-for="da in dasharrays">
                            <svg style="width:100%;height:20px;cursor: pointer;" @click="meta.selstyle.strokedasharray=da;refreshPreview()">
                              <line x1="0" y1="50%" x2="100%" y2="50%" stroke="black" :stroke-width="meta.selstyle.strokewidth" :style="{stroke:meta.selstyle.strokecolor}" :stroke-dasharray="da"/>
                            </svg>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                    <v-col>
                      <v-btn :text="$t('selection')" @click="meta.ondasharray=!meta.ondasharray"/>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="meta.seltype=='Polygon'">
                  <v-row>
                    <v-col align-self="center">{{ $t('fillcolor') }}</v-col>
                    <v-col></v-col>
                    <v-col>
                      <v-btn block variant="outlined" class="position-relative">
                        <input type="color" :value="meta.selstyle.fillcolor" style="position: absolute;width: 90%;height: 90%;" @change="evt=>{
                          meta.selstyle.fillcolor=evt.target.value
                          refreshPreview()
                        }"/>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col align-self="center">{{ $t('facespolygons') }} {{ $t('transparency') }}</v-col>
                    <v-col cols="4">
                      <v-number-input hide-details inset variant="outlined" density="compact" :min="0" v-model="meta.selstyle.fillopacity" @update:model-value="refreshPreview"/>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="meta.seltype=='Manual'">
                  <v-row>
                    <v-col>
                      <input class="sldfile d-none" type="file" accept=".sld" @change="sldFromFile"/>
                      <v-btn block color="info" class="mt-3" :text="$t('uploadfile')" @click="qsel('.sldfile').click()"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea hide-details variant="outlined" style="height: calc(100vh - 600px);resize: none;" v-model="meta.selstyle.sldbody"/>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="meta.seltype!='Manual'&&meta.seltype!='Streetview'">
                  <v-row>
                    <v-col align-self="center">{{ $t('whethertousetext') }}</v-col>
                    <v-col cols="4">
                      <v-switch hide-details color="primary" v-model="meta.selstyle.usetext" @update:model-value="refreshPreview"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3" align-self="center">{{ $t('propertyfieldnames') }}</v-col>
                    <v-col>
                      <v-text-field hide-details variant="outlined" density="compact" :label="$t('propertyfieldnames')" v-model="meta.selstyle.fieldnm"/>
                    </v-col>
                  </v-row>
                  <v-row v-show="false">
                    <v-col>
                      <div>{{ $t('fonts') }}</div>
                      <v-select hide-details variant="outlined" density="compact" :items="meta.fonts" v-model="meta.selstyle.fontnm" @update:model-value="refreshPreview"/>
                    </v-col>
                    <v-col>
                      <div>{{ $t('fonts') }} {{ $t('style') }}</div>
                      <v-select hide-details variant="outlined" density="compact" :items="config.FontStyles" v-model="meta.selstyle.fontstyle" @update:model-value="refreshPreview"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>{{ $t('fontcolorsize') }}</v-col>
                    <v-col>
                      <v-btn block variant="outlined" class="position-relative">
                        <input type="color" :value="meta.selstyle.fontcolor" style="position: absolute;width: 90%;height: 90%;" @change="evt=>{
                          meta.selstyle.fontcolor=evt.target.value
                          refreshPreview()
                        }"/>
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-number-input hide-details inset variant="outlined" density="compact" v-model="meta.selstyle.fontsize" @update:model-value="refreshPreview"/>
                    </v-col>
                  </v-row>
                </div>
            </v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col><v-btn block variant="outlined" :text="$t('preview')" @click="previewmap.clearLayers();refreshPreview()"/></v-col>
                  <v-col><v-btn block variant="elevated" color="error" :text="$t('cancel')" @click="meta.selstyle=null"/></v-col>
                  <v-col><v-btn block variant="elevated" color="primary" :text="$t('save')" :disabled="disabledSave()" @click="pop('save')"/></v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-defaults-provider>
        </v-col>
        <v-col>
          <PreviewMap ref="previewmap" width="100%" height="100%"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</div>
<Teleport v-if="meta.poptype" to="#popbody">
  <ManGroup v-if="meta.poptype=='mangroup'" :usedefaultgroup="true" :tartbl="meta.tartbl"/>
  <ConfirmCard v-if="meta.poptype=='save'||meta.poptype=='del'" :ttl="$t('managestyles')" :cont="meta.poptype" @cancel="pop()" @confirm="()=>{
    if(meta.poptype=='save')modStyle()
    if(meta.poptype=='del')delStyle()
  }"/>
  <Logs v-if="meta.poptype=='log'" ispop showtitle logcate="Layerstyle" :targetid="meta.selid" @close-log="pop()"/>
</Teleport>
</template>
<style scoped>
  .stylemarkericon i{margin: 10px;float: left;font-size: 32px;}
  .unselmarker{border: 1px solid #fff;}
  .selmarker{border: 1px solid #000;}
  .manstyletbl{border: 1px solid #e0e0e0;}
  .manstyletbl th{background-color: #eee !important;text-align: center !important; width: 180px;}
</style>
